'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pipe;

var _enforceFunction2 = require('./internal/_enforceFunction');

var _enforceFunction3 = _interopRequireDefault(_enforceFunction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function piped(operations, arg) {
  var result = arg;
  for (var i = 0; i < operations.length; i++) {
    result = operations[i](result);
  }
  return result;
}

/**
 * Create a function that runs operations from left-to-right.
 *
 * `pipe` is _not_ curried.
 *
 * @example
 * const takeEvensAndDouble = pipe(
 *   filter(n => n % 2 === 0),
 *   map(n => n * 2)
 * );
 *
 * takeEvensAndDouble(List.of(1, 2, 3))
 * // returns List [ 4 ]
 *
 * @param  {Array<Function>} operations any number of unary functions.
 * @return {Function}
 */
function pipe() {
  for (var _len = arguments.length, operations = Array(_len), _key = 0; _key < _len; _key++) {
    operations[_key] = arguments[_key];
  }

  operations.forEach(_enforceFunction3.default);
  return piped.bind(null, operations);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.9/pipe.js
// module id = 383
// module chunks = 0